/**
 * A readable message from an RTK Query rejection.
 *
 * `axiosBaseQuery` normalises failures to `{ status, data }`, where `data` is
 * whatever the backend sent - a plain-text string for most refusals, but an
 * object for some. Rendering that object directly is what produces
 * "[object Object]" on screen, so anything non-string falls back to the
 * caller's own wording rather than being stringified.
 */
export const errorMessage = (err: unknown, fallback: string): string => {
  const data = (err as { data?: unknown })?.data;

  if (typeof data === "string" && data.trim()) {
    // The backend answers "Unknown Error" for anything it did not classify,
    // which tells a user nothing they can act on.
    return data === "Unknown Error" ? fallback : data;
  }

  const message = (data as { message?: unknown })?.message;
  if (typeof message === "string" && message.trim()) return message;

  const bare = (err as { message?: unknown })?.message;
  if (typeof bare === "string" && bare.trim()) return bare;

  return fallback;
};
